'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromSalesImages = fromSalesImages;

var _hubspot = require('hubspot.bender');

function fromSalesImages(path) {
  return _hubspot.staticDomainPrefix + '/salesImages/' + _hubspot.depVersions.salesImages + '/' + path;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/utils/getStaticAsset.js
// module id = 501
// module chunks = 0